/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AdminRole = {
    CarrierRegistrationManager: 'CARRIER_REGISTRATION_MANAGER',
    CarrierComplianceManager: 'CARRIER_COMPLIANCE_MANAGER',
    LoadIssuesManager: 'LOAD_ISSUES_MANAGER'
} as const;
export type AdminRole = typeof AdminRole[keyof typeof AdminRole];

